import React from 'react';
import Header from '../../components/Header/Header';
import {logout} from '../Authentication/LogoutActions';
import {getSelf, passwordUpdateSelf} from './HeaderActions';

import { connect } from 'react-redux';

class HeaderContainer extends React.Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  componentDidMount(){
    const {dispatchGetSelf,self} = this.props;
    let selfData = self.get("data");
    if(selfData){
      if(selfData.organization.orgType !== "GUEST"){
        dispatchGetSelf();
      }
    }else{
      dispatchGetSelf();
    }    
  }

  logout() {
    const { dispatchLogout } = this.props;
    dispatchLogout();
    if (this.props.history) {
      this.props.history.push('/login');
    }
  }

  render() {
    const {self, isAuthenticated, dispatchPasswordUpdateSelf,passwordUpdateSelfData} = this.props;
    return <Header
    passwordUpdateSelfData ={passwordUpdateSelfData}
    dispatchPasswordUpdateSelf={dispatchPasswordUpdateSelf} 
    isAuthenticated={isAuthenticated}
    logout={this.logout} 
    self={self}/>;
  }
}

const mapStateToProps = (state) => {
  return {
    self: state.self,
    isAuthenticated: state.authentication.login.get('isAuthenticated'), 
    passwordUpdateSelfData: state.passwordUpdateSelf
  };
};
const mapDisptatchToProps = (dispatch) => ({
  dispatchLogout: () => dispatch(logout()),
  dispatchGetSelf: () => dispatch(getSelf()),
  dispatchPasswordUpdateSelf: (formData, cb) => dispatch(passwordUpdateSelf(formData, cb))
});

export default connect(mapStateToProps, mapDisptatchToProps)(HeaderContainer);




// WEBPACK FOOTER //
// ./src/containers/Header/HeaderContainer.js